export const getQueryString = ({ incidentTypes, handlers, snoozed }, isSupervisor: boolean) => {
  let queryString = '';

  if (incidentTypes && incidentTypes.length) {
    const query = new URLSearchParams({ types: incidentTypes });

    queryString += decodeURIComponent(query.toString());
  }

  if (isSupervisor) {
    if (handlers && handlers.length) {
      queryString += '&';
      const query = new URLSearchParams({ handlers: handlers });

      queryString += decodeURIComponent(query.toString());
    }
  }

  if (snoozed !== undefined) {
    queryString += '&';
    const query = new URLSearchParams({ snoozed: snoozed });

    queryString += decodeURIComponent(query.toString());
  }

  return queryString;
};

export const isSupervisor = (user: User | null | undefined): boolean => {
  return !!user && user.isSrsSupervisor;
};

export const getRowHighPriorityColor = (data) => {
  return data?.highPriority
    ? { backgroundColor: 'rgba(255, 236, 233, 1)', border: '1px solid rgba(124, 17, 0, 1)' }
    : {};
};

export const getTimePassed = (current: Date, comparison: Date) => {
  const timeDifference = current.getTime() - comparison.getTime();

  const minutes = Math.floor(timeDifference / (1000 * 60));
  const hours = Math.floor(timeDifference / (1000 * 60 * 60));
  const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  let timeAgo = '';

  if (minutes < 60) {
    if (minutes < 0) {
      timeAgo = '< 1 min ago';
    } else {
      timeAgo = `(${minutes} min ago)`;
    }
  } else if (hours < 24) {
    timeAgo = `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else {
    timeAgo = `${days} day${days > 1 ? 's' : ''} ago`;
  }

  return timeAgo;
};
